import React from 'react'
import Moment from 'react-moment'
import { DivText } from './styled'
import { StatusTag } from 'components'

export const options = {
  listSize: [
    { text: '30', value: 30 },
    { text: '60', value: 60 },
    { text: '90', value: 90 },
    { text: '120', value: 120 }
  ],
  status: [
    { value: 15, text: 'Wait to Acknowledge / รอการรับทราบ' },
    { value: 16, text: 'Acknowledged / รับทราบแล้ว' },
    { value: 17, text: 'Excepted / ได้รับยกเว้น' }
  ],
  exceptedReason: [
    { value: 'R001', text: 'R001 หน่วยงานราชการ/รัฐวิสาหกิจ' },
    { value: 'R002', text: 'R002 การซื้อขายครั้งเดียว' },
    { value: 'R003', text: 'R003 การเปิด PO ย้อนหลัง' },
    { value: 'R004', text: 'R004 การทำธุรกรรมเงินสดเท่านั้น' },
    { value: 'R005', text: 'R005 อื่นๆ' }
  ]
}

export const scStatusOption = [
  { key: 1,value: '-',  text: 'All Status' },
  { key: 15,value: 15 , text: 'Wait to Acknowledge' },
  { key: 16,value: 16 , text: 'Acknowledge' },
  { key: 17,value: 17 , text: 'Excepted' },
]

export const columns = {
  tCocList: (cocCol) => {
    return ([
      {
        Header: 'Status',
        accessor: 'status',
        width: 150,
        Cell: row => (<StatusTag status={row.value} statusName={row.original.statusName} />)
      }, {
        Header: 'Document No.',
        accessor: 'documentNumber',
        width: 100,
      }, {
        Header: 'Vendor Name',
        accessor: 'vendorName',
        id: 'vendorName',
        width: 300,
      }, {
        Header: 'Title',
        accessor: 'title',
        width: 200,
      }, {
        Header: 'Version',
        accessor: 'version',
        width: 100,
      }, {
        Header: 'EZP Registered',
        accessor: 'ezProcureRegist',
        width: 100,
      }, {
        Header: 'Purchasing Org',
        accessor: 'purchasingOrg',
        width: 100,
      }, {
        Header: 'Modify By',
        accessor: 'modifiedBy',
        width: 100,
      }, {
        // Use submittedDate casuse API didn't edit
        Header: 'Create Date',
        accessor: 'submittedDate',
        width: 100,
        Cell: row => (
          <DivText>
            {row.value ?
              <Moment format="DD MMM YYYY">{row.value}</Moment>
              :
              '-'
            }
          </DivText>)
      }, {
        Header: 'Modify Date',
        accessor: 'modifiedDate',
        width: 100,
        Cell: row => (
          <DivText>
            {row.value ?
              <Moment format="DD MMM YYYY">{row.value}</Moment>
              :
              '-'
            }
          </DivText>)
      }, {
        Header: 'Excepted Reason',
        accessor: 'exceptedReason',
        width: 100,
      }
    ])
  },
}